import { SwapChild } from '../../components';
import { styled } from 'styled-components';
import { motion } from 'framer-motion';

export const Header = styled.hgroup`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceMd};
  text-align: center;
`;

export const ContactWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spaceLg};
`;

export const ClientWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spaceLg};
  margin-top: ${props => props.theme.spaceLg};
`

export const ProfileImage = styled(motion.img)`
  height: 16rem;
  width: 16rem;
  border-radius: ${props => props.theme.borderFull};
`;

export const ClientGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: ${props => props.theme.spaceMd };
`


const ClientBackground = styled(motion.div)`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
`;

export const ClientImage = styled(ClientBackground)`
background-image: url(${props => props.image});
background-repeat: no-repeat;
background-position: center;
background-size: cover;
z-index: -2;
transition: scale 0.25s ease-in-out, opacity 0.25s ease-in-out;
`;

export const ClientLinkWrapper = styled.button`
border: none;
outline: none;
  height: 8rem;
  width: 8rem;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${props => props.theme.brand};
  color: ${props => props.theme.textColor};
  font-size: ${props => props.theme.sizeSm};
  font-weight: ${props => props.theme.headerWeight};
    letter-spacing: ${props => props.theme.headerSpacing};
    text-transform: uppercase;
  text-transform: uppercase;
  z-index: 1;

  border-radius: ${props => props.theme.borderFull};
  overflow: hidden;
  transition: box-shadow 0.125s ease-in-out;

  &:before {
    position: absolute;
    top: calc(50%  - 8rem);
    left: calc(50% + 8rem);
    width: 16rem;
    height: 16rem;
    border-radius: ${props => props.theme.borderFull};
    content: '';
    border: 1px solid ${props => props.theme.brand + props.theme.clear50};
    transform-origin: center center;
    transition: border 0.25s ease-in-out;
    z-index: -1;
    box-sizing: border-box;
  }
    ${SwapChild} {
        height: 100%;
        width: 100%;
      }
    
      &:hover {
        ${ClientImage} {
          scale: 1.075;
          opacity: 0.25
        }
    
        color: ${props => props.theme.foregroundColor};
    
        &:before {
          border-width: 8rem;
        }
      }
    
      &:active {
        box-shadow: 0 0 0 4px ${props => props.theme.backgroundColor},
          0 0 0 6px ${props => props.theme.brand + props.theme.clear50};
      }
  `


export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spaceXl};

  svg {
    height: ${props => props.theme.sizeH6};
    width: ${props => props.theme.sizeH6};
    min-height: ${props => props.theme.sizeH6};
    min-width: ${props => props.theme.sizeH6};
  }
`;